var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { BaseTextInputField } from "./base_text_input_field";
export var PasswordField = function (props) {
    return React.createElement(BaseTextInputField, __assign({}, props, { type: "password" }));
};
